import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {TooltipDirective} from '../tooltip/tooltip.component';

/** A number that could not be computed (a KPI, a badge, a total): a dash and why, never a 0 (KAB-2441). */
@Component({
	selector: 'app-unavailable-value',
	imports: [TooltipDirective, TranslatePipe],
	template: `<span aria-hidden="true" [tooltip]="'global.loadError.value' | translate">—</span><span class="visually-hidden">{{ 'global.loadError.value' | translate }}</span>`,
	styles: `.visually-hidden { position: absolute; width: 1px; height: 1px; overflow: hidden; clip-path: inset(50%); white-space: nowrap; }`,
})
export class UnavailableValueComponent {}
